export const liveType={
    USER_APPEAR:'出勤',
    USER_ABSENT:'缺席',
    USER_LEAVE:'请假'
}